// #ux-redesign-start: useSidebarCollapsed hook (Paso 3)
// Estado de colapso del sidebar (rail mode 64px vs expandido 240px) con
// persistencia en localStorage 'tsd-sidebar-collapsed'.
//
// PORTABILIDAD: trasplantable a Web-Patients sin cambios.
// ─────────────────────────────────────────────────────────────────────────────

import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'tsd-sidebar-collapsed';

const readStored = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
};

const useSidebarCollapsed = () => {
  const [collapsed, setCollapsedState] = useState(readStored);

  // Sincroniza el atributo data-sidebar en <html> para que el CSS del
  // main-panel pueda reaccionar (padding-left depende del width del sidebar).
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.setAttribute('data-sidebar', collapsed ? 'collapsed' : 'expanded');
  }, [collapsed]);

  const setCollapsed = useCallback((next) => {
    const value = typeof next === 'function' ? next(collapsed) : next;
    setCollapsedState(value);
    try {
      localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    } catch (e) {
      // ignore
    }
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsed((c) => !c), [setCollapsed]);

  return { collapsed, setCollapsed, toggle };
};

export default useSidebarCollapsed;
// #ux-redesign-end
